import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button, Editable,
  EditableInput,
  EditablePreview,
  Flex, Select, Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr
} from "@chakra-ui/react";

import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { ProdutoItemType } from "models/product_item_type";
import { OptionType } from "models/select_mode";
import { useEffect, useRef, useState } from "react";
import useMeasureUnit from "../../measureUnit/hooks/useMeasureUnit";
import ProductInputRow from "./ProductInputRow";
interface IProductItem {
  itens: ProdutoItemType[] | undefined;
  borderColor: string;
  changeItem: (item: ProdutoItemType, index: number) => void;
  deleteRow: (item: ProdutoItemType) => void;
  addRow: (item: ProdutoItemType) => void;
  condicaoPagamentos : CondicaoPagamento[] | undefined;
}

const ProductItem = ({
  itens,
  borderColor,
  changeItem,
  deleteRow,
  addRow,
  condicaoPagamentos
}: IProductItem) => {
  const [descricao, setDescricao] = useState("");
  const [unidade, setUnidade] = useState("");
  const [valorMin, setValorMin] = useState("");
  const [valorMax, setValorMax] = useState("");
  const [diasPgto, setDiasPgto] = useState("");
  const [principal, setPrincipal] = useState(false);
  const [condicaoPagamentoId, setCondicaoPagamentoId] = useState('');
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const unidadeRef = useRef(null);
  const cancelRef = useRef(null);
  const [error, setError] = useState(false);

  const { unidades } = useMeasureUnit();

  const closeError = () => {
    setError(false);
  };

  const editItem = (
    data: ProdutoItemType,
    tipo: string,
    value: string,
    index: number
  ) => {
    const val = itens[index];
    switch (tipo) {
      case "unidade":
        val.unidadeMedidaId = value;
        break;
      case "descricao":
        val.descricao = value;
        break;
      case "dias":
        val.diasPgto = value;
        break;
      case "valorMin":
        val.valorMin = Number(value);
        break;
      case "valorMax":
        val.valorMax = Number(value);
        break;
      case "principal" : 
      val.principal = Boolean(value);
      break;
      case "pagamento" : 
      val.condicaoPagamentoId = value
      break;

      default:
        break;
    }
    data = val;
    changeItem(data, index);
  };

  const changeInput = (tipo: string, value: string) => {
    switch (tipo) {
      case "unidade":
        setUnidade(value);
        break;

      case "descricao":
        setDescricao(value);
        break;

      case "dias":
        setDiasPgto(value);
        break;

      case "valorMin":
        setValorMin(value);
        break;

      case "valorMax":
        setValorMax(value);
        break;

      case "principal" : 
      setPrincipal(Boolean(value));
      break;

      case "pagamento" : 
       setCondicaoPagamentoId(value);
      break;

      default:
        break;
    }
  };

  const add = () => {
    if (unidade === "") {
      showError("Erro!", "Unidade de medida já cadastrada para esse produto");
      return;
    }
    if (condicaoPagamentoId === "") {
      showError("Erro!", "Selecione a Forma de Pagamento");
      return;
    }

    if (valorMin === "" || Number(valorMin) <= 0 || isNaN(Number(valorMin))) {
      showError("Erro!", "Preencha corretamente o campo valor minímo");
      return;
    }

    if (valorMin === "" || Number(valorMax) <= 0 || isNaN(Number(valorMax))) {
      showError("Erro!", "Preencha corretamente o campo valor máximo");
      return;
    }
    const itemAdd: ProdutoItemType = {
      diasPgto: diasPgto,
      descricao: descricao,
      produtoId: "",
      id: "",
      unidadeMedidaId: unidade,
      valorMax: Number(valorMax),
      valorMin: Number(valorMin),
      principal: itens.length === 0 ? true : principal,
      condicaoPagamentoId: condicaoPagamentoId,
    };
    const existe = itens.find(
      (value) => value.unidadeMedidaId === itemAdd.unidadeMedidaId
    );
    if (!existe) {
      addRow(itemAdd);
      cleanInput();
      unidadeRef.current.value = "";
      unidadeRef.current.focus();
    } else {
      showError("Erro!", "Unidade de medida já cadastrada para esse produto");
    }
  };

  const showError = (title: string, msg: string) => {
    setError(true);
    setErrorTitle(title);
    setErrorMsg(msg);
  };

  const cleanInput = () => {
    setDescricao("");
    setUnidade("");
    setDiasPgto("");
    setValorMin("");
    setValorMax("");
    setCondicaoPagamentoId("");
    setPrincipal(false);
  };

  useEffect(() => {}, [itens]);


  return (

      <Table variant="striped" color="gray.500" mb="24px" mt="12px">
        <Thead>
          <Tr>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #UNIDADE
              </Flex>
            </Th>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #DESCRICAO
              </Flex>
            </Th>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #FORMA DE PAGAMENTO
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #PRINCIPAL
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #VALOR MIN
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #VALOR MAX
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #OPÇÕES
              </Flex>
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {itens?.map((item, idx) => {
            return (
              <Tr key={`${item.id}-${item}-${idx}`}>
                <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                 <AutoComplete<OptionType, false, GroupBase<OptionType>>
                        size="md"
                        onChange={(e) => editItem(item, 'unidade', e.value, idx)}
                        placeholder="Busque o Cliente"
                        name={"cliente"}
                        options={unidades?.map((item) => {
                        return {
                            label: item.nome,
                            value: item.id,
                        };
                        })}
                    value={{
                    label: unidades.find((val) =>  val.id === item.unidadeMedidaId)?.nome,
                    value: unidades.find((val) =>  val.id === item.unidadeMedidaId)?.id
                    }}
                    />
                </Td>

                <Td
                  fontSize={{ sm: "14px" }}
                  borderColor="transparent"
                  color={"black"}
                >
                  <Editable defaultValue={item.descricao}>
                    <EditablePreview />
                    <EditableInput
                      onBlur={(e) =>
                        editItem(item, "descricao", e.target.value, idx)
                      }
                    />
                  </Editable>
                </Td>

                <Td
                  fontSize={{ sm: "14px" }}
                  borderColor="transparent"
                  color={"black"}
                >
              <AutoComplete<OptionType, false, GroupBase<OptionType>>
                        size="md"
                        onChange={(e) => editItem(item, 'pagamento', e.value, idx)}
                        placeholder="Forma de Pagamento"
                        name={"Pagamento"}
                        options={condicaoPagamentos?.map((item) => {
                        return {
                            label: item.nome,
                            value: item.id,
                        };
                        })}
                    value={{
                    label: condicaoPagamentos.find((val) =>  val.id === item.condicaoPagamentoId)?.nome,
                    value: condicaoPagamentos.find((val) =>  val.id === item.condicaoPagamentoId)?.id
                    }}
                    />
                </Td>

                <Td fontSize={{ sm: "14px" }} borderColor="transparent" width={180}>
                <Select value={item.principal.toString()}   onChange={(e) =>editItem(item, "principal", e.target.value, idx)}>
                  <option value={'false'}>NÃO</option>
                    <option value={'true'}>SIM</option>
                </Select>
               </Td>

               

                <Td
                  fontSize={{ sm: "14px" }}
                  borderColor="transparent"
                  color={"black"}
                >
                  <Editable defaultValue={Number(item.valorMin).toFixed(2)}>
                    <EditablePreview />
                    <EditableInput
                      onBlur={(e) =>
                        editItem(item, "valorMin", e.target.value, idx)
                      }
                    />
                  </Editable>
                </Td>

                <Td
                  fontSize={{ sm: "14px" }}
                  borderColor="transparent"
                  color={"black"}
                >
                  <Editable defaultValue={Number(item.valorMax).toFixed(2)}>
                    <EditablePreview />
                    <EditableInput
                      onBlur={(e) =>
                        editItem(item, "valorMax", e.target.value, idx)
                      }
                    />
                  </Editable>
                </Td>
                <Td
                  fontSize={{ sm: "14px" }}
                  borderColor="transparent"
                  color={"black"}
                >
                  <Button
                    onClick={() => deleteRow(item)}
                    colorScheme="red"
                    variant="ghost"
                    ml="1"
                  >
                    Excluir
                  </Button>
                </Td>
              </Tr>
            );
          })}
           <ProductInputRow 
            add={add}
            changeInput={changeInput}
            descricao={descricao}
            diasPgto={diasPgto}
            unidade={unidade}
            unidadeRef={unidadeRef}
            unidades={unidades}
            valorMax={valorMax}
            valorMin={valorMin}
            principal={principal}
            condicaoPagamentos={condicaoPagamentos}
            condicaoPagamentoId={condicaoPagamentoId}
           /> 
        </Tbody>
        <AlertDialog
        isOpen={error}
        leastDestructiveRef={cancelRef}
        onClose={closeError}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {errorTitle}
            </AlertDialogHeader>

            <AlertDialogBody>{errorMsg}</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={closeError} colorScheme={"blue"}>
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      </Table>

  );
};

export default ProductItem;
